module.exports = __webpack_public_path__ + "static/media/2.4a00bf36.jpg";